import Routes from '../routes';
import { postRequestHeaders, getBrowser } from '../utils';

export const logScanEvent = async ({ source, sourceContext, isScanSuccess, value }) => {
    try {
        const page = window.location.pathname;
        const tag = value || '(empty)';
        const pathAndQuery = `${page}/scan?tag=${encodeURIComponent(tag)}`;

        const res = await fetch(Routes.Account.RecordScanEvent(), {
            method: 'POST',
            credentials: 'include',
            headers: { ...postRequestHeaders },
            body: JSON.stringify({
                host: window.location.host.substring(0, 50),
                page,
                pathAndQuery,
                isScanSuccess,
                tag,
                context: (sourceContext !== undefined && sourceContext !== null && sourceContext !== '')
                    ? String(sourceContext)
                    : undefined,
                referrer: document.referrer,
                userAgent: window.navigator.userAgent,
                browser: getBrowser(),
            }),
        });
        if (!res.ok) {
            const errBody = await res.text().catch(() => '');
            console.warn(`[RecordScanEvent] ${res.status} ${res.statusText} isScanSuccess=${isScanSuccess} tag=${tag} body=${errBody}`);
        }
    } catch (error) {
        console.error('[RecordScanEvent] fetch failed', error);
    }
};
